import HelperMixin from '../../Shared/HelperMixin.vue';
import axios from 'axios';

export default {
    name: 'Login',
    mixins: [HelperMixin],
    components: {
    },
    created() {
        this.$blockUI.$loading = this.$loading;
        // Runs async: clear server session first (CSRF cookie still valid), then client storage.
        this.prepareLoginPage();
        this.fetchClientIp();
    },
    beforeDestroy() {
        if (this._resendTimer) clearInterval(this._resendTimer);
        if (this._copyResetTimer) clearTimeout(this._copyResetTimer);
    },
    data() {
        return {
            isAuthenticated: false,
            isActive: false,
            showPwd: false,
            form: {
                Password: null,
                Email: null
            },
            ipAddress: null,
            forgot: {
                open: false,
                step: 1,
                identifier: '',
                masked: '',
                ttlMinutes: 10,
                otp: ['', '', '', '', '', ''],
                devOtp: '',
                otpCopied: false,
                newPassword: '',
                confirmPassword: '',
                showPwd: false,
                busy: false,
                resendCountdown: 0,
            },
        };
    },

    computed: {
        otpCode() {
            return (this.forgot.otp || []).join('');
        },
        pwdLenOk()   { return (this.forgot.newPassword || '').length >= 8; },
        pwdHasUpper() { return /[A-Z]/.test(this.forgot.newPassword || ''); },
        pwdHasLower() { return /[a-z]/.test(this.forgot.newPassword || ''); },
        pwdHasDigit() { return /\d/.test(this.forgot.newPassword || ''); },
        pwdStrong() {
            return this.pwdLenOk && this.pwdHasUpper && this.pwdHasLower && this.pwdHasDigit;
        },
    },

    methods: {

        /** Best-effort session reset when showing the login route (no BlockUI flash). */
        async prepareLoginPage() {
            try {
                await this.$http.Logout();
            } catch (e) {
                /* not signed in or network */
            }
            localStorage.removeItem('currentUser-client');
            try {
                localStorage.removeItem('schoolId');
                localStorage.removeItem('schoolName');
            } catch (e) { /* ignore */ }
            document.cookie.split(';').forEach(function (c) {
                document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
            });
        },

        async fetchClientIp() {
            try {
                const response = await axios.get('/Security/CraSysextracts');
                this.ipAddress = response.data && response.data.ip ? response.data.ip : null;
            } catch (error) {
                this.ipAddress = null;
            }
        },

        login() {
            if (!this.form.Email) {
                this.$helper.ShowMessage('warning', 'بيانات ناقصة', '<strong>الرجاء إدخال رقم الهاتف</strong>');
                return;
            }
            if (!this.form.Password) {
                this.$helper.ShowMessage('warning', 'بيانات ناقصة', '<strong>الرجاء إدخال كلمة المرور</strong>');
                return;
            }

            this.$blockUI.Start();
            this.$http.login(this.form)
                .then(response => {
                    this.$blockUI.Stop();
                    localStorage.setItem('currentUser-client', this.encrypt(JSON.stringify(response.data), this.PlatFormPass));

                    const obj = JSON.parse(this.decrypt(localStorage.getItem('currentUser-client'), this.PlatFormPass));

                    if (obj.userType == 50) {
                        this.$router.replace({ path: '/VoucherCardsDashboard' }).catch(function () { });
                    } else if (obj.userType == 40 || obj.userType == 41) {
                        this.$router.replace({ path: '/Schools' }).catch(function () { });
                    } else {
                        this.$router.replace({ path: '/Home' }).catch(function () { });
                    }
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let msg = 'تعذّر الاتصال بالخادم. الرجاء المحاولة لاحقاً.';
                    if (err && err.response && err.response.data) {
                        msg = typeof err.response.data === 'string'
                            ? err.response.data
                            : (err.response.data.message || err.response.data.title || JSON.stringify(err.response.data));
                    }
                    this.$helper.ShowMessage('error', 'خطأ بتسجيل الدخول', msg);
                });
        },

        // ---------- Forgot password modal ----------

        openForgotModal() {
            this.forgot.open = true;
            this.forgot.step = 1;
            this.forgot.identifier = this.form.Email || '';
            this.forgot.otp = ['', '', '', '', '', ''];
            this.forgot.devOtp = '';
            this.forgot.newPassword = '';
            this.forgot.confirmPassword = '';
            this.forgot.busy = false;
        },

        closeForgotModal() {
            this.forgot.open = false;
            if (this._resendTimer) {
                clearInterval(this._resendTimer);
                this._resendTimer = null;
            }
            this.forgot.resendCountdown = 0;
        },

        startResendCountdown(seconds) {
            this.forgot.resendCountdown = seconds;
            if (this._resendTimer) clearInterval(this._resendTimer);
            this._resendTimer = setInterval(() => {
                if (this.forgot.resendCountdown > 0) {
                    this.forgot.resendCountdown--;
                } else {
                    clearInterval(this._resendTimer);
                    this._resendTimer = null;
                }
            }, 1000);
        },

        async requestOtp() {
            if (!this.forgot.identifier) return;
            this.forgot.busy = true;
            try {
                const res = await this.$http.ForgotPassword({ Identifier: this.forgot.identifier });
                const data = res.data || {};
                this.forgot.masked = data.masked || this.forgot.identifier;
                this.forgot.ttlMinutes = data.ttlMinutes || 10;
                this.forgot.devOtp = data.debugOtpCode || '';
                this.forgot.step = 2;
                this.startResendCountdown(45);
                // Autofocus first OTP cell
                this.$nextTick(() => {
                    const first = this.$refs.otp0;
                    if (first && first[0]) first[0].focus();
                });
            } catch (err) {
                const msg = (err.response && err.response.data) ? (typeof err.response.data === 'string' ? err.response.data : (err.response.data.message || 'تعذّر الإرسال')) : 'تعذّر الإرسال';
                this.$helper.ShowMessage('error', 'خطأ', msg);
            } finally {
                this.forgot.busy = false;
            }
        },

        onOtpInput(idx, ev) {
            const v = (ev.target.value || '').replace(/\D/g, '').slice(-1);
            this.$set(this.forgot.otp, idx, v);
            if (v && idx < 5) {
                const nextRef = this.$refs['otp' + (idx + 1)];
                if (nextRef && nextRef[0]) nextRef[0].focus();
            }
        },

        onOtpKeydown(idx, ev) {
            if (ev.key === 'Backspace' && !this.forgot.otp[idx] && idx > 0) {
                const prevRef = this.$refs['otp' + (idx - 1)];
                if (prevRef && prevRef[0]) prevRef[0].focus();
            }
            if (ev.key === 'ArrowLeft' && idx > 0) {
                const prevRef = this.$refs['otp' + (idx - 1)];
                if (prevRef && prevRef[0]) prevRef[0].focus();
            }
            if (ev.key === 'ArrowRight' && idx < 5) {
                const nextRef = this.$refs['otp' + (idx + 1)];
                if (nextRef && nextRef[0]) nextRef[0].focus();
            }
        },

        onOtpPaste(ev) {
            const pasted = (ev.clipboardData || window.clipboardData).getData('text') || '';
            const digits = pasted.replace(/\D/g, '').slice(0, 6).split('');
            if (digits.length === 0) return;
            ev.preventDefault();
            for (let i = 0; i < 6; i++) {
                this.$set(this.forgot.otp, i, digits[i] || '');
            }
            const lastIdx = Math.min(digits.length, 6) - 1;
            this.$nextTick(() => {
                const r = this.$refs['otp' + lastIdx];
                if (r && r[0]) r[0].focus();
            });
        },

        copyDevOtp() {
            const code = this.forgot.devOtp;
            if (!code) return;
            const done = () => {
                this.forgot.otpCopied = true;
                if (this._copyResetTimer) clearTimeout(this._copyResetTimer);
                this._copyResetTimer = setTimeout(() => { this.forgot.otpCopied = false; }, 1800);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(code).then(done).catch(() => {
                    this.fallbackCopy(code); done();
                });
            } else {
                this.fallbackCopy(code); done();
            }
        },

        fallbackCopy(text) {
            try {
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.style.position = 'fixed';
                ta.style.opacity = '0';
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            } catch (e) { /* ignore */ }
        },

        autoFillOtp() {
            const code = this.forgot.devOtp || '';
            if (code.length !== 6) return;
            for (let i = 0; i < 6; i++) {
                this.$set(this.forgot.otp, i, code[i] || '');
            }
            this.$nextTick(() => {
                const last = this.$refs.otp5;
                if (last && last[0]) last[0].focus();
            });
        },

        goToPasswordStep() {
            if (this.otpCode.length !== 6) return;
            this.forgot.step = 3;
        },

        async resetPassword() {
            if (!this.pwdStrong) {
                this.$helper.ShowMessage('warning', 'كلمة مرور ضعيفة', 'الرجاء استيفاء جميع متطلبات كلمة المرور');
                return;
            }
            if (this.forgot.newPassword !== this.forgot.confirmPassword) {
                this.$helper.ShowMessage('error', 'خطأ', 'كلمتا المرور غير متطابقتين');
                return;
            }
            this.forgot.busy = true;
            try {
                await this.$http.ResetPassword({
                    Identifier: this.forgot.identifier,
                    Otp: this.otpCode,
                    NewPassword: this.forgot.newPassword,
                });
                this.forgot.step = 4;
            } catch (err) {
                const msg = (err.response && err.response.data) ? (typeof err.response.data === 'string' ? err.response.data : (err.response.data.message || 'تعذّر تحديث كلمة المرور')) : 'تعذّر تحديث كلمة المرور';
                this.$helper.ShowMessage('error', 'خطأ', msg);
                // If OTP expired/invalid, go back to step 2
                if (/الرمز|انتهت/.test(msg)) {
                    this.forgot.step = 2;
                }
            } finally {
                this.forgot.busy = false;
            }
        },
    }
}
